import React from 'react';
import { QrNewIcon } from '../../assets/icons';
import PropTypes from 'prop-types';

const ActionButton = ({ title, onClick, className }) => {
  return (
    <button 
      className={`add-button ${className || ''}`}
      onClick={onClick}
    >
      <QrNewIcon />
      {title}
    </button>
  );
};

ActionButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default ActionButton; 